export const GET_RESOURCES = 'GET_RESOURCES'
export const GET_RESOURCE = 'GET_RESOURCE'
export const ADD_RESOURCE = 'ADD_RESOURCE'
export const UPDATE_RESOURCE = 'UPDATE_RESOURCE'
export const DELETE_RESOURCE = 'DELETE_RESOURCE'

export const GET_ARCHIVED_RESOURCES = 'GET_ARCHIVED_RESOURCES'
export const ARCHIVE_RESOURCES = 'ARCHIVE_RESOURCES'
export const UNARCHIVE_RESOURCES = 'UNARCHIVE_RESOURCES'

export const GET_RESOURCE_SIGNED_UPLOAD_URL = 'GET_RESOURCE_SIGNED_UPLOAD_URL'
export const CONFIRM_RESOURCE_FILE_UPLOAD = 'CONFIRM_RESOURCE_FILE_UPLOAD'
export const RESOURCE_DELETE_FILE = 'RESOURCE_DELETE_FILE'
